import React, { useState } from 'react'
import { withTheme } from 'theming'
import AddSection from '../addSection'
import EditMenu from '../editMenu'
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu'
import CustomImage from '../../customImage/customImage'
import useTemplateHook from '../templateHook'
import { isEmpty } from 'lodash'

const BroadcastHubCards = ({
  componentData,
  modifyData,
  setModalState,
  isEdit,
  onSwap,
  onDelete,
  onCopy,
  theme,
  onAdd,
}) => {
  const { data, id } = componentData
  const { customNavigate, KalingoLeftArrow, KalingoRightArrow } = useTemplateHook()
  const [hoverState, setHoverState] = useState('')

  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
    })
  }
  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  const handleHoverItems = (name) => {
    if (!isEdit) return
    setHoverState(name)
  }

  const handleRedirect = (linkObj) => {
    customNavigate('INDIRECT', linkObj, isEdit)
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey].data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  function LeftArrow() {
    const { isFirstItemVisible, scrollPrev } = React.useContext(VisibilityContext)
    return (
      <button
        className={` absolute left-0 top-[45%] z-10 bg-transparent px-0 hidden lg:flex justify-center`}
        disabled={isFirstItemVisible}
        onClick={() => scrollPrev()}
        title="Previous Item"
        style={{ width: '3.66032%' }}
      >
        <img src={KalingoLeftArrow} style={{ height: '37px' }} alt="KalingoLeftArrow" />
      </button>
    )
  }

  function RightArrow() {
    const { isLastItemVisible, scrollNext } = React.useContext(VisibilityContext)
    return (
      <button
        className={`absolute right-0 top-[45%] z-10 bg-transparent px-0 hidden lg:flex justify-center`}
        disabled={isLastItemVisible}
        onClick={() => scrollNext()}
        title="Next Item"
        style={{ width: '3.66032%' }}
      >
        <img src={KalingoRightArrow} style={{ height: '37px' }} alt="KalingoLeftArrow" />
      </button>
    )
  }
  return (
    <div
      className={`w-full relative ${isEdit && hoverState && 'component-hover-class'}`}
      style={{
        backgroundColor: getStyleValue('component_background', 'primary_color', theme.c1),
        padding: '0px 3.66032%',
      }}
      onMouseOver={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
    >
      {isEdit && hoverState.length > 0 && (
        <EditMenu
          onDelete={() => onDelete(id)}
          onMoveUp={() => onSwap(id, 'up')}
          onMoveDown={() => onSwap(id, 'down')}
          onEdit={() => handleModal()}
          onCopy={() => onCopy(id)}
        />
      )}
      <div className="py-[16px] lg:py-8">
        <h2
          style={{
            color: getStyleValue('heading', 'color', theme.c2),
            fontFamily: getStyleValue('heading', 'font', ''),
            textAlign: getStyleValue('heading', 'alignment', ''),
          }}
          className={`xl:text-2xl md:text-xl text-xs ${getStyleValue(
            'heading',
            'font_format',
            'font-bold',
          )} mb-3`}
        >
          {data?.heading}
        </h2>
        <div className="w-full text-[#fefefe]">
          <ScrollMenu
            LeftArrow={LeftArrow}
            RightArrow={RightArrow}
            wrapperClassName="w-full md:mt-4"
          >
            {data?.slide_data &&
              data?.slide_data.map((info, index) => (
                <Card
                  key={index}
                  itemId={`index${index}`}
                  index={index}
                  info={info}
                  handleRedirect={handleRedirect}
                  theme={theme}
                  headingStyle={{
                    color: getStyleValue('card_heading_style', 'color', theme.c3),
                    fontFamily: getStyleValue('card_heading_style', 'font', ''),
                  }}
                  headingFormat={getStyleValue(
                    'card_heading_style',
                    'font_format',
                    'font-semibold',
                  )}
                  subHeadingStyle={{
                    color: getStyleValue('card_subheading_style', 'color', theme.c4),
                    fontFamily: getStyleValue('card_subheading_style', 'font', ''),
                  }}
                  subHeadingFormat={getStyleValue('card_subheading_style', 'font_format', '')}
                />
              ))}
          </ScrollMenu>
        </div>
      </div>
      {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}
    </div>
  )
}

function Card({
  index,
  info,
  handleRedirect,
  theme,
  headingStyle,
  subHeadingStyle,
  subHeadingFormat,
  headingFormat,
}) {
  const { getTemplateImage, SmallLiveImage } = useTemplateHook()
  return (
    <div
      key={index}
      className={`${
        index > 0 ? 'ml-2 xl:ml-3' : ''
      } mr-2 xl:mr-3 2xl:w-[230px] lg:w-[183px] sm:w-[170px] w-[139px] static-img-scale `}
      style={{
        // color: theme.c4,
        cursor: 'pointer',
        position: 'relative',
      }}
      onClick={() => handleRedirect(info?.link)}
    >
      <div className="border rounded-md overflow-hidden w-full">
        <CustomImage
          imageUrl={getTemplateImage(info?.image_s3key)}
          imgClass="z-0 w-full h-auto  "
          imgStyle={{ aspectRatio: '1.77777' }}
          loaderClass="z-0 w-full h-2/3"
          loaderStyle={{
            background: '#5A5A5A50',
          }}
          imgAlt={'class img"'}
        />
      </div>
      <img
        src={SmallLiveImage}
        alt="live-icon"
        className="2xl:w-8 md:w-6 w-3"
        style={{ position: 'absolute', top: '5%', left: '5%' }}
      />
      <p
        className={` w-full 2xl:text-base xl:text-[15px] md:text-xs text-[10px] mt-[4px] ${headingFormat}`}
        style={{ marginBottom: '0', ...headingStyle }}
      >
        {info?.heading}
      </p>
      <p
        className={`2xl:text-sm xl:text-[13px] text-[10px] font-normal line-clamp-2 ${subHeadingFormat}`}
        style={{ marginBottom: '0', ...subHeadingStyle }}
      >
        {info?.sub_heading}
      </p>
    </div>
  )
}

export default withTheme(BroadcastHubCards)
